import React, { useEffect, useRef, useState } from "react";
import {
  Chip,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import AlertBox from "../../component/AlertBox";
import DialogBox from "../../component/DialogBox";
import ButtonCompo from "../../component/ButtonCompo";
import SelectField from "../../component/SelectField";
import InputField from "../../component/InputField";
import { SERVER_URL } from "../../constant";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import PaginationBar from "../../component/PaginationBar";
import { BsSliders } from "react-icons/bs";
import { LuFilter } from "react-icons/lu";
import { IoDocumentText } from "react-icons/io5";
import AccrodianBox from "../../component/AccrodianBox";
import RightDrawer from "../../component/RightDrawer";
import { MdCloudUpload } from "react-icons/md";

function TicketManagement() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [ticketData, setTicketData] = useState([]);
  const [reload, setReload] = useState(false);
  const [progress, setProgress] = useState("");
  const [status, setStatus] = useState();
  const [enableStatusBtn, setEnableStatusBtn] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState("");
  const [closingStatement, setClosingStatement] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [selectedSearch, setSelectedSearch] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("");
  const [selectedTicketType, setSelcetedTicketType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(true);
  const [selectedProgress, setSelectedProgress] = useState("");
  const [replyDocs, setReplyDocs] = useState([]);
  const replyDocsRef = useRef(null);

  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  console.log(employeeData);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  // fetch employee data
  async function getTickets() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/ticket/get/all/${employeeData?.adminRole}/${page}?search=${selectedSearch}&priority=${selectedPriority}&ticketType=${selectedTicketType}&status=${selectedStatus}&progress=${selectedProgress}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTicketData(res.data?.data?.data);
      setTotalPages(res.data?.data?.totalPages);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage("Ticket fetch failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // change progress
  async function changeProgress(event, ticketId) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/ticket/update/progress/${ticketId}/${event.target.value}`,
        method: "get",
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Progress changed succesfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function uploadAdminDocs(ticketId) {
    const formData = new FormData();
    Array.from(replyDocs).map((file, i) => {
      formData.append("adminTicketFile", file);
    });
    formData.append("ticketId", ticketId);
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/upload/documents`,
        method: "post",
        withCredentials: true,
        data: formData,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Documents have been uploaded successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
      setReplyDocs([]);
    }
  }

  // change status
  async function changeStatus() {
    if (
      selectedTicketId?.length === 0 ||
      status === undefined ||
      closingStatement?.length === 0
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage("Closing statement is required");
      return null;
    }
    const data = {
      ticketId: selectedTicketId,
      status: status,
      closingStatement: closingStatement,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/ticket/update/status`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Status changed succesfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // set value to progress and status field
  function setValue(data) {
    setProgress(data?.progress);
    setStatus(data?.status);
    setClosingStatement(data?.closingStatement);
  }

  // progress and status options array
  const progressArr = [
    {
      title: "Raised",
      value: "Raised",
    },
    {
      title: "In Progress",
      value: "In Progress",
    },
    {
      title: "Resolved",
      value: "Resolved",
    },
    {
      title: "Rejected",
      value: "Rejected",
    },
  ];

  const statusArr = [
    {
      title: "Open",
      value: true,
    },
    {
      title: "Close",
      value: false,
    },
  ];

  const selectedStatusArray = [
    {
      title: "Opened",
      value: true,
    },
    {
      title: "Closed",
      value: false,
    },
  ];

  const selectedTicketTypeArray = [
    {
      title: "Incident",
      value: "Incident",
    },
    {
      title: "New Request",
      value: "New Request",
    },
  ];

  useEffect(() => {
    getTickets();
  }, [reload, page]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <section className="flex justify-between items-center">
            <h1 className="text-[30px] font-medium text-left w-full">
              Tickets
            </h1>
            <section className="flex items-center gap-3">
              <DialogBox
                trigger={
                  <ButtonCompo startIcon={<LuFilter />}>Filter</ButtonCompo>
                }
                title="Filter"
                closeActionButton="Cancel"
                actionButton={
                  <ButtonCompo onClick={() => setReload((prev) => !prev)}>
                    Apply
                  </ButtonCompo>
                }
              >
                <div>
                  <div>
                    <InputField
                      label="Search"
                      helperText="Search with Employee ID, employee name, employee role, subject and ticket number."
                      onChange={(event) =>
                        setSelectedSearch(event?.target?.value)
                      }
                    />
                  </div>
                  <div>
                    <section>
                      <section className="space-y-2 py-3 rounded-lg">
                        <p className="text-[15px] text-slate-700 font-medium">
                          Ticket Priority
                        </p>
                        <section className="flex justify-start items-center gap-3">
                          <ButtonCompo
                            onClick={() => setSelectedPriority("High")}
                            size={"small"}
                            variant={
                              selectedPriority === "High"
                                ? "contained"
                                : "outlined"
                            }
                            color={"error"}
                          >
                            High
                          </ButtonCompo>
                          <ButtonCompo
                            onClick={() => setSelectedPriority("Medium")}
                            size={"small"}
                            variant={
                              selectedPriority === "Medium"
                                ? "contained"
                                : "outlined"
                            }
                            color={"warning"}
                          >
                            Medium
                          </ButtonCompo>
                          <ButtonCompo
                            onClick={() => setSelectedPriority("Low")}
                            size={"small"}
                            variant={
                              selectedPriority === "Low"
                                ? "contained"
                                : "outlined"
                            }
                            color={"success"}
                          >
                            Low
                          </ButtonCompo>
                        </section>
                      </section>
                    </section>
                  </div>
                  <div className="flex justify-center items-end gap-3 mt-3">
                    <SelectField
                      label="Ticket Status"
                      valueArray={selectedStatusArray}
                      value={selectedStatus}
                      setValue={(event) =>
                        setSelectedStatus(event?.target?.value)
                      }
                    />
                    <SelectField
                      label="Ticket Type"
                      valueArray={selectedTicketTypeArray}
                      value={selectedTicketType}
                      setValue={(event) =>
                        setSelcetedTicketType(event?.target?.value)
                      }
                    />
                  </div>
                  <div className="mt-3">
                    <SelectField
                      label="Ticket Progress"
                      valueArray={progressArr}
                      value={selectedProgress}
                      setValue={(event) =>
                        setSelectedProgress(event?.target?.value)
                      }
                    />
                  </div>
                </div>
              </DialogBox>
            </section>
          </section>
          <div className="mt-5 w-full">
            {ticketData?.length === 0 ? (
              <div className="flex justify-center items-center flex-col gap-3">
                <p className="text-slate-500 font-medium text-center mt-5">
                  No ticket raised yet
                </p>
              </div>
            ) : (
              <div className="w-full mt-5">
                <div className="overflow-auto">
                  <Table className="border">
                    <TableHead>
                      <TableRow className="bg-blue-500">
                        <TableCell
                          colSpan={2}
                          className="!text-center !text-white"
                        >
                          Ticket Number
                        </TableCell>
                        <TableCell
                          colSpan={1}
                          className="!text-center !text-white"
                        >
                          Priority
                        </TableCell>
                        <TableCell colSpan={2} className="!text-white">
                          Ticket Description
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          Created At
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          Closed At
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          Request To
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          Progress
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          View
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ticketData?.map((e, i) => (
                        <>
                          <TableRow className="hover:bg-blue-100/30 cursor-pointer">
                            <TableCell colSpan={2} className="!text-center">
                              <span className="bg-blue-200/50 px-3 py-1 rounded-full font-medium text-[14px] text-blue-700">
                                {e?.ticketNumber}
                              </span>
                            </TableCell>
                            <TableCell colSpan={1} className="!text-center">
                              <Chip
                                label={e?.priority}
                                color={
                                  e?.priority === "High"
                                    ? "error"
                                    : e?.priority === "Medium"
                                    ? "warning"
                                    : "success"
                                }
                              />
                            </TableCell>
                            <TableCell colSpan={2}>
                              <div>
                                <div>
                                  <p className="font-medium">
                                    {e?.subject}{" "}
                                    {e?.status === true ? (
                                      <span className="ml-2 px-3 py-1 bg-green-200/70 text-green-700 rounded-full font-medium text-[13px]">
                                        Open
                                      </span>
                                    ) : (
                                      <span className="ml-2 px-3 py-1 bg-red-200/70 text-red-700 rounded-full font-medium text-[13px]">
                                        Closed
                                      </span>
                                    )}
                                    <span className="ml-2">
                                      <Chip label={e?.ticketType} />
                                    </span>
                                  </p>
                                  <p className="text-slate-500 mt-2 w-[0vw] lg:w-[30vw] truncate">
                                    {e?.body}
                                  </p>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell colSpan={3} className="!text-center">
                              {new Date(e?.openOn).toLocaleDateString("en-US", {
                                timeZone: "Asia/Kolkata",
                              })}
                            </TableCell>
                            <TableCell colSpan={3} className="!text-center">
                              {e?.closeOn === undefined
                                ? "--"
                                : new Date(e?.closeOn).toLocaleDateString(
                                    "en-US",
                                    {
                                      timeZone: "Asia/Kolkata",
                                    }
                                  )}
                            </TableCell>
                            <TableCell colSpan={3} className="!text-center">
                              {e?.requestTo === "headHr"
                                ? "HR"
                                : e?.requestTo === "itHelpDesk"
                                ? "IT Helpdesk (Sys Admin)"
                                : "Facility Team"}
                            </TableCell>
                            <TableCell colSpan={3} className="!text-center">
                              {e?.progress === "Raised" ? (
                                <span className="text-[13.8px] bg-slate-200 px-3 py-1 font-medium text-slate-700 rounded-full">
                                  Raised
                                </span>
                              ) : e?.progress === "In Progress" ? (
                                <span className="text-[13.8px] bg-yellow-200 px-3 py-1 font-medium text-yellow-700 rounded-full">
                                  In Progress
                                </span>
                              ) : e?.progress === "Resolved" ? (
                                <span className="text-[13.8px] bg-green-200 px-3 py-1 font-medium text-green-700 rounded-full">
                                  Resolved
                                </span>
                              ) : (
                                <span className="text-[13.8px] bg-red-200 px-3 py-1 font-medium text-red-700 rounded-full">
                                  Rejected
                                </span>
                              )}
                            </TableCell>
                            <TableCell>
                              <RightDrawer
                                actionButton={
                                  <ButtonCompo onClick={() => setValue(e)}>
                                    View
                                  </ButtonCompo>
                                }
                                width="45"
                              >
                                <div className="p-5">
                                  <p className="text-right text-red-500 text-[13px] uppercase font-medium tracking-wide cursor-pointer">
                                    Close
                                  </p>
                                  <div onClick={(eve) => eve.stopPropagation()}>
                                    <p className="font-medium">
                                      Ticket Information{" "}
                                      <span className="bg-blue-200/50 px-3 py-1 rounded-full font-medium text-[14px] text-blue-700 ml-1">
                                        {e?.ticketNumber}
                                      </span>
                                      {e?.status === true ? (
                                        <span className="ml-2 px-3 py-1 bg-green-200/70 text-green-700 rounded-full font-medium text-[13px]">
                                          Open
                                        </span>
                                      ) : (
                                        <span className="ml-2 px-3 py-1 bg-red-200/70 text-red-700 rounded-full font-medium text-[13px]">
                                          Closed
                                        </span>
                                      )}
                                    </p>
                                  </div>
                                  <div onClick={(eve) => eve.stopPropagation()}>
                                    <div className="w-full mt-7">
                                      <div className="flex w-full justify-start items-center gap-[5rem]">
                                        <section>
                                          <p className="font-medium text-[15px] mb-1">
                                            Employee ID
                                          </p>
                                          <span className="bg-blue-200/50 px-3 py-1 rounded-full font-medium text-[14px] text-blue-700">
                                            {e?.employeeId}
                                          </span>
                                        </section>
                                        <section>
                                          <p className="font-medium text-[15px]">
                                            Raised By
                                          </p>
                                          <p className="text-slate-500 mt-1">
                                            {e?.employeeName}
                                          </p>
                                        </section>
                                        <section>
                                          <p className="font-medium text-[15px]">
                                            Role
                                          </p>
                                          <p className="text-slate-500 mt-1">
                                            {e?.employeeRole}
                                          </p>
                                        </section>
                                      </div>
                                      <div className="mt-5 border p-3 rounded-lg shadow-md">
                                        <section>
                                          <p className="text-[14px] text-slate-500 mb-1">
                                            Subject
                                          </p>
                                          <p className="font-medium">
                                            {e?.subject}
                                          </p>
                                        </section>
                                        <section className="mt-3">
                                          <p className="text-[14px] text-slate-500 mb-1">
                                            Description
                                          </p>
                                          <p className="text-slate-800">
                                            {e?.body}
                                          </p>
                                        </section>
                                      </div>
                                      {e?.employeeDocs?.length > 0 ? (
                                        <div className="mt-5">
                                          <AccrodianBox
                                            title={"Employee Documents"}
                                          >
                                            <div className="grid grid-cols-5 gap-3">
                                              {e?.employeeDocs?.map(
                                                (data, i) => (
                                                  <Link
                                                    to={`${SERVER_URL}/api/v1/file/view/${data}`}
                                                    target="_blank"
                                                  >
                                                    <section className="flex flex-col justify-center items-center border p-3 rounded-md hover:bg-blue-50/50">
                                                      <IoDocumentText
                                                        size={45}
                                                        className="text-blue-500"
                                                      />
                                                      <p className="text-[15px] text-blue-600 font-medium truncate w-[6rem]">
                                                        {data}
                                                      </p>
                                                    </section>
                                                  </Link>
                                                )
                                              )}
                                            </div>
                                          </AccrodianBox>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {e?.adminDocs?.length > 0 ? (
                                        <div className="mt-5">
                                          <AccrodianBox
                                            title={"Reply Documents"}
                                          >
                                            <div className="grid grid-cols-5 gap-3">
                                              {e?.adminDocs?.map((data, i) => (
                                                <Link
                                                  to={`${SERVER_URL}/api/v1/file/view/${data}`}
                                                  target="_blank"
                                                >
                                                  <section className="flex flex-col justify-center items-center border p-3 rounded-md hover:bg-blue-50/50">
                                                    <IoDocumentText
                                                      size={45}
                                                      className="text-blue-500"
                                                    />
                                                    <p className="text-[15px] text-blue-600 font-medium truncate w-[6rem]">
                                                      {data}
                                                    </p>
                                                  </section>
                                                </Link>
                                              ))}
                                            </div>
                                          </AccrodianBox>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      <div className="mt-5">
                                        <p className="text-slate-500 uppercase font-medium text-[13px]">
                                          Upload Documents
                                        </p>
                                        <section className="mt-3">
                                          <input
                                            type="file"
                                            multiple
                                            className="hidden"
                                            onChange={(event) =>
                                              setReplyDocs(event.target.files)
                                            }
                                            ref={replyDocsRef}
                                          />
                                          <section
                                            className=" flex flex-col gap-1 justify-center items-center border-slate-400/60 border py-3 rounded-md cursor-pointer"
                                            onClick={() =>
                                              replyDocsRef.current.click()
                                            }
                                          >
                                            <div className="flex justify-center items-center gap-2">
                                              <MdCloudUpload
                                                size={25}
                                                className="text-blue-600"
                                              />
                                              <p className="text-blue-600">
                                                Upload Documents
                                              </p>
                                            </div>
                                            {replyDocs.length > 5 ? (
                                              <p className="text-[15px] text-red-500">
                                                Maximum 5 files can be uploaded
                                              </p>
                                            ) : (
                                              <p className="text-[15px] text-slate-500">
                                                {replyDocs.length === 0
                                                  ? "No files selected"
                                                  : `${replyDocs.length} files selected`}
                                              </p>
                                            )}
                                          </section>
                                        </section>
                                        {replyDocs.length > 0 &&
                                        replyDocs.length <= 5 ? (
                                          <section className="mt-3 flex justify-end">
                                            <ButtonCompo
                                              variant={"contained"}
                                              startIcon={<MdCloudUpload />}
                                              onClick={() =>
                                                uploadAdminDocs(e?._id)
                                              }
                                            >
                                              Upload
                                            </ButtonCompo>
                                          </section>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      <div className="flex justify-between items-center w-full mt-5 gap-5">
                                        <SelectField
                                          label={"Progress"}
                                          value={progress}
                                          valueArray={progressArr}
                                          setValue={(event) =>
                                            changeProgress(event, e?._id)
                                          }
                                        />
                                        <SelectField
                                          label={"Status"}
                                          value={status}
                                          valueArray={statusArr}
                                          setValue={(event) => {
                                            setStatus(event.target.value);
                                            setSelectedTicketId(e?._id);
                                            setEnableStatusBtn(true);
                                          }}
                                        />
                                      </div>
                                      <div className="mt-5">
                                        {status === false ? (
                                          <InputField
                                            label="Closing Statement"
                                            value={closingStatement}
                                            multiline
                                            onChange={(event) =>
                                              setClosingStatement(
                                                event?.target?.value
                                              )
                                            }
                                            required
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      {enableStatusBtn === true ? (
                                        <div className="flex items-end justify-end mt-5">
                                          <ButtonCompo onClick={changeStatus}>
                                            save changes
                                          </ButtonCompo>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </RightDrawer>
                            </TableCell>
                            {/* <TableCell className="!text-center">
                              <DialogBox
                                trigger={
                                  <ButtonCompo onClick={() => setValue(e)}>
                                    View
                                  </ButtonCompo>
                                }
                                maxWidth="sm"
                                title={
                                  <p className="font-medium">
                                    Ticket Information{" "}
                                    <span className="bg-blue-200/50 px-3 py-1 rounded-full font-medium text-[14px] text-blue-700 ml-1">
                                      {e?.ticketNumber}
                                    </span>
                                    {e?.status === true ? (
                                      <span className="ml-2 px-3 py-1 bg-green-200/70 text-green-700 rounded-full font-medium text-[13px]">
                                        Open
                                      </span>
                                    ) : (
                                      <span className="ml-2 px-3 py-1 bg-red-200/70 text-red-700 rounded-full font-medium text-[13px]">
                                        Closed
                                      </span>
                                    )}
                                  </p>
                                }
                              >
                                <div className="w-full">
                                  <div className="flex w-full justify-start items-center gap-[5rem]">
                                    <section>
                                      <p className="font-medium text-[15px] mb-1">
                                        Employee ID
                                      </p>
                                      <span className="bg-blue-200/50 px-3 py-1 rounded-full font-medium text-[14px] text-blue-700">
                                        {e?.employeeId}
                                      </span>
                                    </section>
                                    <section>
                                      <p className="font-medium text-[15px]">
                                        Raised By
                                      </p>
                                      <p className="text-slate-500 mt-1">
                                        {e?.employeeName}
                                      </p>
                                    </section>
                                    <section>
                                      <p className="font-medium text-[15px]">
                                        Role
                                      </p>
                                      <p className="text-slate-500 mt-1">
                                        {e?.employeeRole}
                                      </p>
                                    </section>
                                  </div>
                                  <div className="mt-5 border p-3 rounded-lg shadow-md">
                                    <section>
                                      <p className="text-[14px] text-slate-500 mb-1">
                                        Subject
                                      </p>
                                      <p className="font-medium">
                                        {e?.subject}
                                      </p>
                                    </section>
                                    <section className="mt-3">
                                      <p className="text-[14px] text-slate-500 mb-1">
                                        Description
                                      </p>
                                      <p className="text-slate-800">
                                        {e?.body}
                                      </p>
                                    </section>
                                  </div>
                                  {e?.employeeDocs?.length > 0 ? (
                                    <div className="mt-5">
                                      <AccrodianBox
                                        title={"Employee Documents"}
                                      >
                                        <div className="grid grid-cols-4 gap-3">
                                          {e?.employeeDocs?.map((data, i) => (
                                            <Link
                                              to={`${SERVER_URL}/api/v1/file/view/${data}`}
                                              target="_blank"
                                            >
                                              <section className="flex flex-col justify-center items-center border p-3 rounded-md hover:bg-blue-50/50">
                                                <IoDocumentText
                                                  size={45}
                                                  className="text-blue-500"
                                                />
                                                <p className="text-[15px] text-blue-600 font-medium truncate w-[6rem]">
                                                  {data}
                                                </p>
                                              </section>
                                            </Link>
                                          ))}
                                        </div>
                                      </AccrodianBox>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {e?.adminDocs?.length > 0 ? (
                                    <div className="mt-5">
                                      <AccrodianBox title={"Reply Documents"}>
                                        <div className="grid grid-cols-4 gap-3">
                                          {e?.adminDocs?.map((data, i) => (
                                            <Link
                                              to={`${SERVER_URL}/api/v1/file/view/${data}`}
                                              target="_blank"
                                            >
                                              <section className="flex flex-col justify-center items-center border p-3 rounded-md hover:bg-blue-50/50">
                                                <IoDocumentText
                                                  size={45}
                                                  className="text-blue-500"
                                                />
                                                <p className="text-[15px] text-blue-600 font-medium truncate w-[6rem]">
                                                  {data}
                                                </p>
                                              </section>
                                            </Link>
                                          ))}
                                        </div>
                                      </AccrodianBox>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <div className="flex justify-between items-center w-full mt-5 gap-5">
                                    <SelectField
                                      label={"Progress"}
                                      value={progress}
                                      valueArray={progressArr}
                                      setValue={(event) =>
                                        changeProgress(event, e?._id)
                                      }
                                    />
                                    <SelectField
                                      label={"Status"}
                                      value={status}
                                      valueArray={statusArr}
                                      setValue={(event) => {
                                        setStatus(event.target.value);
                                        setSelectedTicketId(e?._id);
                                        setEnableStatusBtn(true);
                                      }}
                                    />
                                  </div>
                                  <div className="mt-5">
                                    {status === false ? (
                                      <InputField
                                        label="Closing Statement"
                                        value={closingStatement}
                                        multiline
                                        onChange={(event) =>
                                          setClosingStatement(
                                            event?.target?.value
                                          )
                                        }
                                        required
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  {enableStatusBtn === true ? (
                                    <div className="flex items-end justify-end mt-5">
                                      <ButtonCompo onClick={changeStatus}>
                                        save changes
                                      </ButtonCompo>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </DialogBox>
                            </TableCell> */}
                          </TableRow>
                        </>
                      ))}
                    </TableBody>
                  </Table>
                  <PaginationBar
                    attendancePage={page}
                    setAttendancePage={setPage}
                    totalAttendancePage={totalPages}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default TicketManagement;
